import { config } from "../../constants/constant";

export const aggregatorEndpoints = {
  DOCUMENT_TYPE_LIST: config.BASE_URI + "/api/v2/document_type",
};
